var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComedyMask = function SvgComedyMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-280q66 0 113-47t47-113H320q0 66 47 113t113 47M280-600h160q0-33-23.5-56.5T360-680t-56.5 23.5T280-600m240 0h160q0-33-23.5-56.5T600-680t-56.5 23.5T520-600M480-80q-75 0-140.5-28.5t-114-77-77-114T120-440v-440h720v440q0 75-28.5 140.5t-77 114-114 77T480-80m0-80q116 0 198-82t82-198v-360H200v360q0 116 82 198t198 82m0-320"
  })));
};
export default SvgComedyMask;